// @flow

import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';

export type Props = {
  handleSubmit: Function,
};

const CopyArticleForm = ({handleSubmit}: Props) => (
  <div className="CopyArticleForm">
    <form onSubmit={handleSubmit}>
      <Field
        name="objectId"
        label="Nytt lägenhetsnummer"
        component={BasicFormInput}
        type="text" />
      <button
        type="submit"
        className="button success expanded">
        Skapa kopia
      </button>
    </form>
  </div>
);

export default reduxForm({
  form: 'copyApartment',
})(CopyArticleForm);



// WEBPACK FOOTER //
// ./src/components/CopyArticleForm/CopyArticleForm.js